import {observer} from "mobx-react"
import {PageContentTitle, ScrollTable} from "../../ui"
import {cmsDetailStore} from "../../../store"
import {useState} from "react";

const CmsHistory = observer(function CmsHistory() {
    const [expanded, setExpanded] = useState(false)
    return <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        fontSize: '0.8em',

    }}>
        <PageContentTitle
            actionItem={<button onClick={() => setExpanded(!expanded)}>
                    <span
                        className="material-symbols-outlined">{expanded ? 'expand_circle_down' : 'expand_circle_up'}</span>
            </button>}
        ><span style={{fontWeight: 'bold'}}>Historie</span></PageContentTitle>
        {expanded &&
            <div style={{
                maxHeight: '25em',
                minHeight: '25em',
                display: 'flex'
            }}>
                <ScrollTable>
                    <thead>
                    <tr>
                        <th style={{width: "5em"}}>Version</th>
                        <th>Name</th>
                        <th>Anzeigename</th>
                        <th>Kundennummer (SAP)</th>
                        <th>Adresse</th>
                        <th>Änderungsdatum</th>
                        <th>Benutzer</th>
                    </tr>
                    </thead>
                    <tbody>
                    {cmsDetailStore.history.map((val, index) => {
                        return <tr key={index}>
                            <td>{val.audit?.version === undefined ? '-' : val.audit?.version}</td>
                            <td>{val.data.name}</td>
                            <td>{val.data.displayName}</td>
                            <td>{val.data.customerNumber}</td>
                            <td>{val.data.address.street} {val.data.address.houseNumber} {val.data.address.addition}, {val.data.address.postCode} {val.data.address.city} {val.data.address.country}</td>
                            <td>{val.audit?.lastModifiedDate}</td>
                            <td>{val.audit?.lastModifiedBy}</td>
                        </tr>
                    })}
                    </tbody>
                </ScrollTable>
            </div>
        }
    </div>
})

export {
    CmsHistory
}
